import { CONTACT_US_IF_FURTHER_HELP, getAccountSettingsCTA } from "./shared";
export var LoginEmailIA = function LoginEmailIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getAccountSettingsCT;
        return (_getAccountSettingsCT = getAccountSettingsCTA(context, strictLocalize)) === null || _getAccountSettingsCT === void 0 ? void 0 : _getAccountSettingsCT.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getAccountSettingsCT2, _getAccountSettingsCT3;
        return (_getAccountSettingsCT2 = getAccountSettingsCTA(context, strictLocalize)) === null || _getAccountSettingsCT2 === void 0 ? void 0 : (_getAccountSettingsCT3 = _getAccountSettingsCT2.getLink) === null || _getAccountSettingsCT3 === void 0 ? void 0 : _getAccountSettingsCT3.call(_getAccountSettingsCT2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return LOGIN_EMAIL_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [LOGIN_EMAIL_DESCRIPTION_1(strictLocalize), LOGIN_EMAIL_DESCRIPTION_2(strictLocalize), CONTACT_US_IF_FURTHER_HELP(strictLocalize)];
    }
  };
};
var LOGIN_EMAIL_TITLE = function LOGIN_EMAIL_TITLE(strictLocalize) {
  return strictLocalize({
    id: "MnAW1K",
    defaultMessage: [{
      "type": 0,
      "value": "Modifier l'e-mail de connexion"
    }]
  });
};
var LOGIN_EMAIL_DESCRIPTION_1 = function LOGIN_EMAIL_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "8O9zrI",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez modifier votre adresse e-mail de connexion en cliquant sur l'icône utilisateur dans le coin supérieur droit du portail de la marque, puis en sélectionnant l'option « Paramètres du compte »."
    }]
  });
};
var LOGIN_EMAIL_DESCRIPTION_2 = function LOGIN_EMAIL_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "Pj8C4e",
    defaultMessage: [{
      "type": 0,
      "value": "Dans l'onglet « Mon compte », repérez la section « Informations personnelles » et saisissez la nouvelle adresse e-mail de connexion dans le champ « E-mail personnel ». Enfin, cliquez sur le bouton « Enregistrer » pour sauvegarder les modifications apportées sur cette page."
    }]
  });
};